import MultiOccurrenceGraph from './graph/MultiOccurrenceGraph';
import TrackableObservationGraph from './graph/TrackableObservationGraph';
export default {
  MultiOccurrenceGraph: MultiOccurrenceGraph,
  TrackableObservationGraph: TrackableObservationGraph
};